import React, { Fragment } from "react"

import {
  AccordionComponent as Accordion,
  Summary,
  Details,
  Text,
} from "components/ui/Accordion"

const Content = () => {
  return (
    <Fragment>
      <Accordion>
        <Summary>1. Üldsätted</Summary>
        <Details>
          <Text>
            1.1. Käesolevad iseteeninduse kasutustingimused (edaspidi{" "}
            <strong>Tingimused</strong>) reguleerivad Fresh Finance OÜ
            iseteeninduskeskkonna (edaspidi <strong>Iseteenindus</strong>)
            kasutamist füüsiliste ja juriidiliste isikute poolt, kellel on või
            on olnud AS-i PlusPlus Capital (registrikood 11919806, aadress Tartu
            mnt 83, 10115, edaspidi <strong>PlusPlus Capital</strong>) või
            PlusPlus Baltic OÜ (registrikood 12273105, aadress Tartu mnt 83,
            10115 Tallinn, edaspidi <strong>PlusPlus Baltic</strong>, PlusPlus
            Capital ja PlusPlus Baltic edaspidi koos nimetatud ka kui{" "}
            <strong>Võlausaldajad</strong>) ees rahaline kohustus ja kes on
            kantud Iseteenindusega seotud Fresh Finance-i süsteemidesse
            (edaspidi <strong>Klient</strong>). Fresh Finance tegeleb muuhulgas,
            kuid mitte ainult Iseteeninduse vahendusel Võlausaldajate nimel
            krediidihaldustegevusega Krediidiinkassode- ja ostjate seaduse
            tähenduses.
          </Text>
          <Text>
            1.2. Iseteenindus võimaldab Kliendil saada ülevaadet Kliendi
            kohustustega seonduvatest andmetest ja teha arvutivõrgu vahendusel
            Fresh Finance-i poolt võimaldatud makseid ja muid toiminguid.
          </Text>
          <Text>
            1.3. Iseteenindust kasutades kinnitab Klient, et on Tingimustega
            tutvunud, nõustub Tingimustega ja kohustub neid järgima. Tingimused
            on Kliendile siduvad.
          </Text>
          <Text>
            1.4. Lisaks Tingimustele on Klient Iseteenindusse sisenedes ja seal
            toimingute tegemisel kohustatud järgima Fresh Finance-i poolt
            Iseteeninduses antud mistahes lisajuhiseid.
          </Text>
          <Text>
            1.5. Fresh Finance jätab endale õiguse ühepoolselt muuta
            Iseteeninduse funktsioone ja Iseteeninduse kaudu võimaldatavate
            teenuste ja toimingute mahtu ning nende kasutamise korda Klienti
            sellest teavitamata.
          </Text>
          <Text>
            1.6. Fresh Finance-il on õigus Tingimusi igal ajal muuta, teavitades
            sellest Klienti Iseteeninduse või veebilehe (
            <a
              href="https://freshfinance.ee"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.freshfinance.ee
            </a>
            ) kaudu. Tingimuste muudatused jõustuvad muudatuste Iseteeninduses
            või veebilehel avaldamise kuupäevast, kui muudetud Tingimustes ei
            ole sätestatud teisiti.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>2. Iseteenindusse sisenemine ja turvalisus</Summary>
        <Details>
          <Text>
            2.1. Iseteeninduse kasutamiseks tuleb Kliendil Iseteenindusse sisse
            logida, kasutades selleks ID-kaardi, Mobiil-ID või Smart-ID
            lahendust.
          </Text>
          <Text>
            2.2. Fresh Finance-l on õigus nõuda täiendavaid dokumente ja infot,
            et kontrollida isikusamasust või isiku esitatud teavet ning muuta
            Iseteeninduses kasutatavat isikusamasuse tuvastamise protsessi.
          </Text>
          <Text>
            2.3. Iseteeninduse kasutamiseks vajaliku ja sobiva tark- ja
            riistvara olemasolu peab Klient tagama ise. Klient on kohustatud
            tagama, et tema turva- ja muud lahendused (sh viirusetõrje programm)
            vastavad kaasaegsetele standarditele ja ei blokeeri Iseteeninduse
            kasutamist.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>3. Kliendi õigused, kohustused ja vastutus</Summary>
        <Details>
          <Text>
            3.1. Klient ei tohi kasutada Iseteenindust mis tahes ebaseaduslikul
            viisil või õigusrikkumise toimepanemiseks.
          </Text>
          <Text>
            3.2. Klient ei tohi kasutada Iseteenindust selle kättesaadavuse või
            funktsionaalsuse seireks või muudel konkureerimise eesmärkidel.
          </Text>
          <Text>
            3.3. Klient vastutab õiguslike tagajärgede eest, mis tulenevad mis
            tahes maksetest, maksekorraldustest, juhistest, taotlustest,
            dokumentidest ja muust teabest, mille Klient on Iseteeninduses
            esitanud.
          </Text>
          <Text>
            3.4. Klient ei tohi kasutada Iseteenindust programmide vahendusel,
            mis saadavad Iseteenindusele automaatseid päringuid. Samuti on
            keelatud robotite, jälitus- ja otsinguseadmete, andmete sorteerija
            ja muude automaatsete andmesisestus- ja töötlusseadmete kasutamine.
          </Text>
          <Text>
            3.5. Klient kohustub hoidma:
            <ul>
              <li>
                3.5.1. Iseteenindusse sisse logimiseks või isikusamasuse
                tuvastamiseks tarvilikke andmeid ja vahendeid (nt sülearvuti,
                mobiiltelefon), sh ID kaarti, paroole ja kasutajatunnuseid
                turvaliselt, nii et need ei satuks kolmandate isikute
                valdusesse;
              </li>
              <li>
                3.5.2. Turvaliselt ja mitte avalikustama kolmandatele isikutele
                mistahes muud Kliendi, Võlausaldajate või Fresh Finance-ga
                seotud konfidentsiaalset teavet ning vältima kolmandate isikute
                juurdepääsu nimetatud teabele;
              </li>
              <li>
                3.5.3. Oma Iseteeninduses kuvatavad andmed ajakohased ja
                korrektsed hoidma ning viivitamatult teavitama esitatud teabe,
                (isiku)andmete ja/või dokumentide muutumisest.
              </li>
            </ul>
          </Text>
          <Text>
            3.6. Klient vastutab Iseteeninduse kaudu võetud kõigi kohustuste ja
            tehtud toimingute eest, samuti Kliendi sisestatud andmete õigsuse
            eest.
          </Text>
          <Text>
            3.7. Klient on teadlik ja kinnitab, et Iseteeninduse kaudu esitatud
            Kliendi tahteavaldused, dokumendid ja tehtud toimingud on
            õiguslikult siduvad, omavad omakäeliselt allkirjastatud
            dokumentidega võrdset õiguslikku jõudu ning Klient vastutab kõigi
            tekkinud Kliendi kohustuste eest. Fresh Finance-il on õigus nõuda
            Iseteeninduse kaudu esitatavate dokumentide digitaalset
            allkirjastamist.
          </Text>
          <Text>
            3.8. Klient võib igal ajal Iseteeninduse kasutamisest loobuda,
            teavitades Fresh Finance-i vastavast soovist veebilehe kaudu
            (www.freshfinance.ee). Sellele järgneb Fresh Finance-i Kliendi
            ligipääsu Iseteenindusele blokeerimine.
          </Text>
          <Text>
            3.9. Kui Klient soovib esitada küsimusi või edastada tähelepanekuid
            Iseteeninduse kohta, saab ta pöörduda e-posti aadressil
            support@freshfinance.ee.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>4. Fresh Finance-i õigused ja kohustused</Summary>
        <Details>
          <Text>
            4.1. Fresh Finance kohustub tagama Kliendile võimaluse kasutada
            Iseteenindust vastavalt käesolevatele kasutustingimustele.
          </Text>
          <Text>
            4.2. Fresh Finance tagab Klienti puudutava teabe konfidentsiaalsuse
            ning avaldab Klienti puudutavat teavet kolmandatele isikutele ainult
            privaatsusteates ja seadustes nimetatud juhtudel.
          </Text>
          <Text>
            4.3. Fresh Finance-il on õigus takistada või piirata Iseteenindusse
            juurdepääsu või jätta Iseteeninduses tehtud toimingud
            aktsepteerimata, juhul kui:
            <ul>
              <li>
                4.3.1. Fresh Finance-ile on teatavaks saanud asjaolu, mille
                alusel võib järeldada, et Iseteeninduses Kliendi toimingu
                tegemiseks vajalikud vahendid on teatavaks saanud kolmandale
                isikule; või
              </li>
              <li>
                4.3.2. Fresh Finance on tuvastanud Iseteenindusse sisenemiseks
                või toimingute teostamiseks kasutatud arvuti osas Iseteeninduse
                vastu suunatud tegevuse; või
              </li>
              <li>
                4.3.3. Fresh Finance on tuvastanud Iseteeninduse kasutamise
                viisil, mis on vastuolus kehtivate õigusaktidega; või
              </li>
              <li>4.3.4. Klient on rikkunud Tingimusi; või</li>
              <li>
                4.3.5. Klient on rikkunud Fresh Finance-iga sõlmitud kokkulepet
                või lepingust tulenevaid kohustusi ning ei ole nimetatud
                kohustusi täitnud Fresh Finance-i poolt antud täiendava tähtaja
                jooksul.
              </li>
            </ul>
          </Text>
          <Text>
            4.4. Fresh Finance-il on õigus igal ajal Iseteeninduse teenuse
            pakkumine ajutiselt või lõplikult lõpetada, teavitades sellest
            Klienti.
          </Text>
          <Text>
            4.5. Kui Fresh Finance-il tekib kahtlus Kliendi poolt Iseteeninduse
            kaudu esitatud dokumentide või andmete ehtsuse või õigsuse kohta, on
            Fresh Finance-il õigus nõuda Kliendilt täiendavate dokumentide või
            andmete esitamist ning Kliendil on kohustus need esitada.
          </Text>
          <Text>
            4.6. Fresh Finance ei vastuta Kliendile tekkinud kahju eest, kui
            Kliendi poolt volitamata isik siseneb Kliendi andmeid ja paroole
            kasutades Iseteenindusse ning teeb Kliendi nimel makseid, edastab
            dokumente või teeb muid Iseteeninduse võimaldatud tegevusi.
          </Text>
          <Text>
            4.7. Fresh Finance ei vastuta rikete ja häirete eest Iseteeninduse
            töös, mille põhjustanud on Kliendi seadmed, Kliendi e-posti
            konfiguratsioon, ülekoormatus või Kliendi arvuti mittevastavus
            Iseteeninduse kasutamiseks vajalike tehnoloogiliste nõuetega.
          </Text>
          <Text>
            4.8. Fresh Finance-il on õigus Iseteeninduse funktsioone, tooteid,
            teenuseid, nende mahtu ja osutamise korda muuta ning teha vastavaid
            uuendusi Iseteeninduse paremaks toimimiseks.
          </Text>
          <Text>
            4.9. Fresh Finance-i kontaktandmed ning teadete edastamise viisid on
            avaldatud Fresh Finance-i veebilehel. Kontaktandmete muutmisel ei
            ole Fresh Finance kohustatud Klienti sellest eraldi teavitama, välja
            arvatud juhul, kui tingimustes või muudes sõlmitud lepingutes on
            kokku lepitud teisiti või see tuleneb seadusest.
          </Text>
          <Text>
            4.10. Fresh Finance ei vastuta häirete ja rikete eest Iseteeninduse
            töös, kui nende põhjuseks on häired ja rikked Kliendi seadme töös,
            sobimatute või litsentseerimata seadmete või programmide kasutamine,
            elektrikatkestused, Kliendi arvuti mittevastavus Iseteeninduse
            kasutamiseks vajalike tehnoloogiliste nõuetega või vääramatu jõud
            (loodusjõud, riigivõimuorganite tegevus jm).
          </Text>
          <Text>
            4.11. Juhul kui Klient ei täida punktis 3.5.3 nimetatud kohustust,
            on Fresh Finance-il õigus eeldada, et Kliendi varem esitatud teave,
            (isiku)andmed ja dokumendid on õiged, kuni Klient ei teata
            vastupidist.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>5. Intellektuaalne omand</Summary>
        <Details>
          <Text>
            5.1. Kõik Iseteeninduse ja selles avaldatud teostega seotud
            autoriõigused ja autoriõigustega kaasnevad õigused kuuluvad Portaali
            omanikule.
          </Text>
          <Text>
            5.2. Iseteeninduses on kasutatud kaubamärke, mille omanikuks on
            PlusPlus Baltic OÜ või samasse kontserni kuuluv ettevõte.
            Kaubamärgid on kaitstud seaduse kohaselt ning nende kasutamine ilma
            kirjaliku loata on keelatud.
          </Text>
          <Text>
            5.3. Iseteeninduses on kasutatud kaubamärke, mille omanikuks on
            Fresh Finance OÜ või samasse kontserni kuuluv ettevõte. Kaubamärgid
            on kaitstud kehtivatele seadustele vastavalt ja nende kasutamine
            ilma kirjaliku loata on keelatud.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>6. Isikuandmete töötlemine</Summary>
        <Details>
          <Text>
            6.1. Fresh Finance töötleb Iseteenindusega seoses Kliendi
            isikuandmeid, mis on juba Fresh Finance-i süsteemides olemas ja
            isikuandmeid, mille Klient on Iseteenindusse sisestanud (sh Kliendi
            isiku tuvastamiseks Iseteenindusse sisselogimisel) või mis on Fresh
            Finance-ile Kliendiga suhtlemise käigus muul viisil teatavaks
            saanud. Fresh Finance töötleb Kliendi isikuandmeid vastavalt
            privaatsusteatele.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>7. Lõppsätted</Summary>
        <Details>
          <Text>
            7.1. Iseteeninduse Kasutustingimustele kohaldatakse Eesti Vabariigis
            kohalduvaid õigusakte.
          </Text>
          <Text>
            7.2. Pretensiooni korral tuleb Kliendil pretensioon esitada
            kirjalikult või kirjalikku taasesitamist võimaldavas vormis.
            Pretensioonis tuleb viidata asjaoludele ja/või dokumentidele, mille
            alusel pretensioon esitatakse. Kui Klient viitab pretensioonis
            dokumendile, mis ei ole Fresh Finance-le vabalt kättesaadav, tuleb
            see dokument pretensioonile lisada.
          </Text>
          <Text>
            7.3. Fresh Finance vaatab pretensiooni läbi ja teatab otsusest
            kirjalikult või kirjalikku taasesitamist võimaldaval viisil
            hiljemalt:
            <ul>
              <li>
                7.3.1. 15 kalendripäeva jooksul alates pretensiooni
                vastuvõtmisest kui tegemist on füüsilisest isikust kliendiga; ja
              </li>
              <li>
                7.3.2. 30 kalendripäeva jooksul alates pretensiooni
                vastuvõtmisest kui tegemist on juriidilisest isikust kliendiga.
              </li>
            </ul>
          </Text>
          <Text>
            7.4. Poolte vahel tekkinud vaidlused püütakse lahendada
            läbirääkimiste teel. Juhul kui vaidluste lahendamine läbirääkimiste
            teel ei õnnestu, lahendatakse Poolte vaidlused Harju Maakohtus,
            välja arvatud juhul kui seadusest tuleneb teisiti.
          </Text>
          <Text>
            7.5. Kasutustingimused kehtivad alates 11. veebruarist 2025.
          </Text>
        </Details>
      </Accordion>
    </Fragment>
  )
}

export default Content
